import { getFormattedRef } from '@soulhx/fs-common';
import { clsx } from '@soulhx/ui-common';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IRef {
  abbreviationLocal: string;
  copyright?: string;
  fullCopyright: boolean;
  passage: string;
  forceHideRef?: boolean;
}
export const Ref = ({ abbreviationLocal, copyright, fullCopyright, passage, forceHideRef = false }: IRef) => {
  const { t } = useTranslation(['bibleviewer']);
  const [showCopyright, setShowCopyright] = useState(false);

  if (!copyright || copyright.trim().length < 1) return null;

  return (
    <div className={clsx('bibleviewer-ref', (fullCopyright || forceHideRef) && 'bibleviewer-ref-hidden')}>
      <div className="ref-text">
        {getFormattedRef(passage, { includeVerses: false })}
        <span className="abbreviation-span" onClick={() => setShowCopyright((oldValue) => !oldValue)}>
          {t('bibleviewer:versionAbbreviation', { abbrev: abbreviationLocal })}
        </span>
      </div>
      {showCopyright && <div className={clsx('copyright-text')}>{copyright}</div>}
    </div>
  );
};
